import { Button, Modal, Row } from 'antd'
import LinesImportForm from '../../../../components/Purchasing/Order/ImportLines/LinesImportForm'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import React, { Fragment } from 'react'

function LinesImport(props) {
  const {
    visible,
    modalType,
    submitting,
    submit,
    update,
    formRef,
    onCancel,
    removing,
    remove,
    isUpdatable,
    isRemovable,
    onShow,
  } = props

  const isNew = modalType === 'new'

  return (
    <Fragment>
      <Modal
        visible={visible}
        title={'Import VendorQuote Lines'}
        onCancel={onCancel}
        destroyOnClose={true}
        footer={
          <FooterButtons
            disabled={!isUpdatable}
            remove={remove}
            visible={isUpdatable || isNew}
            removing={removing}
            submit={submit}
            update={update}
            submitting={submitting}
            title={'Import VendorQuote Lines'}
            isNew={isNew}
            isEdit={!isNew}
            isRemovable={isRemovable}
          />
        }
        width={'75%'}>
        <Row>
          <LinesImportForm ref={formRef} {...props} />
        </Row>
      </Modal>
      <Button
        data-testid={'add'}
        type={'default'}
        size="small"
        icon={'plus'}
        disabled={!isUpdatable}
        style={{ marginLeft: 10 }}
        onClick={onShow}>
        Import Lines
      </Button>
    </Fragment>
  )
}

export default LinesImport
